import * as yup from 'yup';

export const signInFormSchema = yup.object().shape({
  cod: yup.string().required('Digite o código enviado a seu email'),
});
